<template>
  <v-card flat>
    <v-col
      class="py-0 pa-2 pb-1"
      cols="12"
    >
      <a type="primary" size="xsmall" @click="handleGetBack(false)">
        <v-icon size="12" class="backIcon">mdi-arrow-left</v-icon>
        {{ $t('message.actions.return') }}
      </a>
    </v-col>
    <v-row class="py-0 pa-2">
      <v-col cols="12">
        <v-card flat>
          <div>
            <span class="body-bold-medium">{{
              $t('message.pages.video.miniTrigger.miniTrigger')
            }}</span>
          </div>
          <span class="body-regular-smaller subTitle-enable-thumb">
            {{ $t('message.pages.video.miniTrigger.description') }}
          </span>
          <a target="_blank" type="secondary" @click="handleGoToArticle">
            <span class="body-bold-smaller">
              {{ $t('message.knowMore') }}
            </span>
            <v-icon class="body-bold-smaller" size="12">mdi-open-in-new</v-icon>
          </a>
        </v-card>
      </v-col>
    </v-row>

    <v-col cols="12" class="mt-2 ml-0">
      <template v-if="loadings.creatingCta">
        <v-skeleton-loader
          type="image"
          height="48px"
          style="margin-top: 1px"
        ></v-skeleton-loader>
        <v-skeleton-loader
          type="image"
          height="48px"
          style="margin-top: 1px"
        ></v-skeleton-loader>
        <v-skeleton-loader
          type="image"
          height="34px"
          width="148px"
          class="mt-4"
        ></v-skeleton-loader>
      </template>
      <v-row class="px-2" v-else>
        <div class="d-flex flex-column">
          <span class="body-bold-base">
            {{ $t('message.pages.video.miniTrigger.miniTrigger') }}
          </span>
          <span
            class="body-regular-smaller neutral-40-light--text mb-4"
            :class="{
              'd-none': allCtasVideo.length,
            }"
          >
            {{ $t('message.pages.video.miniTrigger.noneMiniTrigger') }}
          </span>
        </div>
        <v-col cols="12" style="display: grid; gap: 10px">
          <v-row
            class="justify-space-between"
            style="flex-wrap: nowrap; gap: 10px; cursor: pointer"
            v-for="(trigger, index) in allCtasVideo"
            :key="`defaultThumb_${index}`"
          >
            <div class="d-flex flex-wrap align-center" style="gap: 10px">
              <template>
                <previewThumbCard
                  style="height: 32px; width: 48px; min-width: 48px !important"
                  :key="`defaultThumb_${index}`"
                  :loadingDelete="false"
                  :heightImage="'32px'"
                  :thumb="trigger.metadata.previewImage.url"
                  :showCloseBtn="false"
                  :selected="false"
                  :showDownloadBtn="false"
                />
                <div style="display: grid">
                  <span class="body-regular-small">{{ trigger.title }}</span>
                  <span class="body-regular-smaller"
                    >{{ trigger.metadata.startTime }} -
                    {{ trigger.metadata.endTime }}</span
                  >
                </div>
              </template>
            </div>
            <div
              v-if="!trigger.removeThumb && !loadings.removingCta"
              class="d-flex align-center"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <base-btn
                    @click="handleEditCta(trigger, index)"
                    v-bind="attrs"
                    v-on="on"
                    class="panda-icons --thumbnail"
                    type="neutral"
                    :disabled="loading"
                  >
                    <v-icon
                      :disabled="loading"
                      style="
                        font-size: 16px;
                        color: var(--neutral-40-light-light) !important;
                      "
                      >panda-edit</v-icon
                    ></base-btn
                  >
                </template>
                <span>{{ $t('message.actions.edit') }}</span>
              </v-tooltip>
              <v-menu min-width="208px" offset-y bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <base-btn
                    type="neutral"
                    class="panda-menu-action panda-icons --thumbnail"
                    :disabled="loading"
                    v-bind="attrs"
                    v-on="on"
                    color="neutral-light"
                    style="font-size: 16px"
                  />
                </template>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-title @click="handleEditCta(trigger, index)">
                      {{ $t('message.pages.video.miniTrigger.buttons.edit') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title
                      @click="
                        handleDownloadThumb(
                          trigger.metadata.previewImage.url,
                          trigger.title
                        )
                      "
                    >
                      {{
                        $t('message.pages.video.miniTrigger.buttons.download')
                      }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title
                      @click="handleRemoveCta(trigger)"
                      style="color: red !important"
                    >
                      {{ $t('message.pages.video.miniTrigger.buttons.remove') }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div v-else class="d-flex align-center">
              <v-progress-circular
                indeterminate
                :size="16"
                :width="3"
                color="brand"
              ></v-progress-circular>
            </div>
          </v-row>
          <v-row
            :class="{
              'mt-4': allCtasVideo.length,
            }"
          >
            <base-btn
              type="secondary"
              size="small"
              v-if="hasEditVideoPerm"
              :disabled="loading || loadings.removingCta"
              @click="openUploadMiniTrigger = true"
            >
              <v-icon>mdi-plus</v-icon>
              {{ $t('message.pages.video.miniTrigger.add') }}
            </base-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <!-- <v-col cols="12" v-else class="px-2">
      <v-row no-gutters>
        <v-col cols="12">
          <input-images
            @handleInput="(data) => saveImageLink(data)"
            :previewImage="editingMiniTrigger.metadata.previewImage.url"
          />
        </v-col>
        <v-col cols="12" class="mt-6">
          <v-row no-gutters>
            <v-col cols="12" class="pr-2">
              {{ $t('message.pages.video.miniTrigger.name') }}</v-col
            >
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="editingMiniTrigger.title"
            dense
            outlined
            hide-details
            :placeholder="$t('message.pages.video.miniTrigger.name')"
            :disabled="!hasEditVideoPerm"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="mt-2">
          <v-row no-gutters>
            <v-col cols="6" class="pr-2">{{
              $t('message.pages.videoPlayerButtons.start')
            }}</v-col>
            <v-col cols="6" class="pl-2">{{
              $t('message.pages.videoPlayerButtons.end')
            }}</v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="6" class="pr-2">
              <AntTimePicker
                :startVal="(editingMiniTrigger.metadata||{}).startTime"
                :timeVideo="timeVideo"
                :disabled="
                  (editingMiniTrigger.metadata||{}).lastAllVideo || !hasEditVideoPerm
                "
                @changedTime="
                  (time) => ((editingMiniTrigger.metadata||{}).startTime = time)
                "
              />
            </v-col>
            <v-col cols="6" class="pl-2">
           <AntTimePicker
                :key="
                  isLowerOrEqual
                    ? editingMiniTrigger.metadata.startTime
                    : editingMiniTrigger.metadata.endTime
                "
                :startVal="
                  isLowerOrEqual
                    ? editingMiniTrigger.metadata.startTime
                    : editingMiniTrigger.metadata.endTime
                "
                :thresholdTime="editingMiniTrigger.metadata.startTime"
                :timeVideo="timeVideo"
                :disabled="
                  editingMiniTrigger.metadata.lastAllVideo ||
                  editingMiniTrigger.metadata.lastTillEnd ||
                  !hasEditVideoPerm
                "
                @changedTime="
                  (time) => (editingMiniTrigger.metadata.endTime = time)
                "
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-2">
          <v-row no-gutters>
            <v-col cols="6" class="pr-2">
              <v-checkbox
                v-model="editingMiniTrigger.metadata.lastAllVideo"
                :label="$t('message.pages.videoPlayerButtons.lastAllVideo')"
                class="pa-0 ma-0"
                color="primary"
                hide-details
                :disabled="!hasEditVideoPerm"
                @click="handleLastAllVideo"
              ></v-checkbox>
            </v-col>
            <v-col cols="6" class="pl-2">
              <v-checkbox
                v-model="editingMiniTrigger.metadata.lastTillEnd"
                :label="$t('message.pages.videoPlayerButtons.lastTillEnd')"
                dense
                class="pa-0 ma-0"
                color="primary"
                hide-details
                :disabled="!hasEditVideoPerm"
                @click="handleLastTillEnd"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col> -->
    <unsaved-changes-modal />
    <v-dialog
      :fullscreen="isMobileBreakpoint"
      persistent
      v-model="openUploadMiniTrigger"
      width="600px"
    >
      <base-drop-zone
        v-if="!isEditing"
        :title="$t('message.pages.video.miniTrigger.miniTrigger')"
        @close-upload="handleCancelEditing"
        @file-uploaded="processFileInput"
      />
      <v-card v-if="isEditing">
        <v-toolbar class="ml-2" elevation="0">
          <v-toolbar-title class="text--subtitle">
            {{ $t('message.pages.video.miniTrigger.miniTrigger') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="handleCancelEditing">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="flex: 100%">
          <div style="display: flex; justify-content: center">
            <div style="width: 300">
              <div
                :style="{
                  background: `url(${
                    ((editingMiniTrigger.metadata || {}).previewImage || {}).url
                  })`,
                  height: '200px',
                  width: '380px',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  display: 'flex',
                }"
                style="border-radius: 4px"
              ></div>
            </div>
          </div>
        </v-card-text>
        <v-card-text style="height: 350px; overflow: auto; padding-top: 24px">
          <v-row no-gutters v-if="editingMiniTrigger.metadata">
            <v-col cols="12">
              <v-input
                :label="$t('message.name')"
                v-model="editingMiniTrigger.title"
                :error="checkNameIsExist"
                :maxLength="40"
                :counter="showCounter ? 40 : null"
                @focus="showCounter = true"
                @blur="showCounter = false"
                dense
                :messages="checkNameIsExist ? 'Este nome já foi utilizado' : ''"
                :placeholder="$t('message.pages.video.thumbnails.thumbName')"
              ></v-input>
            </v-col>
            <v-col cols="12"><v-divider class="my-4"></v-divider></v-col>
            <v-col cols="12"
              ><span class="body-bold-base neutral-20-dark-text">{{
                $t('message.pages.video.display')
              }}</span></v-col
            >
            <v-col cols="12" class="mt-4">
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div style="display: grid">
                    <span class="neutral-20-dark-text">{{
                      $t('message.pages.video.miniTrigger.modal.showAlways')
                    }}</span>
                    <span class="body-regular-smaller subTitle-enable-thumb">{{
                      $t('message.pages.videoPlayerButtons.lastAllVideoSub')
                    }}</span>
                  </div>
                  <v-switch
                    v-if="
                      allCtasVideo.length < 1 ||
                      initialEditingMiniTrigger.metadata.lastAllVideo
                    "
                    v-model="editingMiniTrigger.metadata.lastAllVideo"
                    color="primary"
                    class="ma-0 toggle-input"
                    hide-details
                    @change="handleLastAllVideo"
                  ></v-switch>
                  <v-tooltip v-else bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-switch
                          disabled
                          color="primary"
                          class="ma-0 toggle-input"
                          hide-details
                          @change="handleLastAllVideo"
                        ></v-switch>
                      </div>
                    </template>
                    <span>{{
                      $t('message.pages.video.miniTrigger.tooltips.warning')
                    }}</span>
                  </v-tooltip>
                </v-row>
              </v-col>
            </v-col>

            <v-col cols="12" class="mt-4">
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div style="display: grid">
                    <span class="neutral-20-dark-text">{{
                      $t('message.pages.video.miniTrigger.modal.showSpecific')
                    }}</span>
                    <span class="body-regular-smaller subTitle-enable-thumb">{{
                      $t('message.pages.videoPlayerButtons.chooseTimeVideoSub')
                    }}</span>
                  </div>
                  <v-switch
                    v-model="showAll"
                    :value="showAll"
                    color="primary"
                    class="ma-0 toggle-input"
                    hide-details
                    @change="toggleLastAllVideoState"
                  ></v-switch>
                </v-row>
              </v-col>
            </v-col>

            <v-col
              v-if="!editingMiniTrigger.metadata.lastAllVideo"
              cols="12"
              class="mt-4 mb-1"
            >
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <span class="neutral-20-dark-text">
                    {{ $t('message.pages.videoPlayerButtons.start') }}
                  </span>
                  <!-- start -->
                  <AntTimePicker
                    v-if="checkIfIsBetweenInterval"
                    class="hide-icon-time-picker error-timer"
                    :startVal="(editingMiniTrigger.metadata || {}).startTime"
                    :style="{ width: this.timeVideo >= 3600 ? '70px' : '' }"
                    :timeVideo="timeVideo"
                    :disabled="
                      (editingMiniTrigger.metadata || {}).lastAllVideo ||
                      !hasEditVideoPerm
                    "
                    @changedTime="handleStartTimeEvent"
                  />
                  <AntTimePicker
                    v-else
                    class="hide-icon-time-picker"
                    :startVal="(editingMiniTrigger.metadata || {}).startTime"
                    :style="{ width: timeVideo >= 3600 ? '70px' : '' }"
                    :timeVideo="timeVideo"
                    :disabled="
                      (editingMiniTrigger.metadata || {}).lastAllVideo ||
                      !hasEditVideoPerm
                    "
                    @changedTime="handleStartTimeEvent"
                  />
                </v-row>

                <v-row
                  class="mt-4"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <span class="neutral-20-dark-text">{{
                    $t('message.pages.pauseThumbnail.end')
                  }}</span>
                  <AntTimePicker
                    v-if="checkIfIsBetweenInterval"
                    class="hide-icon-time-picker error-timer"
                    :startVal="editingMiniTrigger.metadata.endTime"
                    :thresholdTime="editingMiniTrigger.metadata.startTime"
                    :style="{ width: timeVideo >= 3600 ? '70px' : '' }"
                    :timeVideo="timeVideo"
                    :disabled="
                      editingMiniTrigger.metadata.lastAllVideo ||
                      editingMiniTrigger.metadata.lastTillEnd ||
                      !hasEditVideoPerm
                    "
                    @changedTime="handleEndTimeEvent"
                  />
                  <AntTimePicker
                    v-else
                    class="hide-icon-time-picker"
                    :key="editingMiniTrigger.metadata.endTime"
                    :style="{ width: timeVideo >= 3600 ? '70px' : '' }"
                    :startVal="
                      isLowerOrEqual
                        ? editingMiniTrigger.metadata.startTime
                        : editingMiniTrigger.metadata.endTime
                    "
                    :thresholdTime="editingMiniTrigger.metadata.startTime"
                    :timeVideo="timeVideo"
                    :disabled="
                      editingMiniTrigger.metadata.lastAllVideo ||
                      editingMiniTrigger.metadata.lastTillEnd ||
                      !hasEditVideoPerm
                    "
                    @changedTime="handleEndTimeEvent"
                  />
                </v-row>
              </v-col>
            </v-col>
            <v-col
              v-if="
                checkIfIsBetweenInterval &&
                !editingMiniTrigger.metadata.lastAllVideo
              "
              cols="12"
            >
              <span
                class="red--text caption align-text align-end"
                style="display: flex; justify-content: flex-end"
              >
                {{ $t('message.pages.video.miniTrigger.existMiniTrigger') }}
              </span>
            </v-col>
            <v-col
              cols="12"
              class="mt-4"
              v-if="!editingMiniTrigger.metadata.lastAllVideo"
            >
              <v-col>
                <v-row
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <span class="neutral-20-dark-text">{{
                    $t('message.pages.video.miniTrigger.modal.showAtEnd')
                  }}</span>
                  <v-switch
                    v-model="editingMiniTrigger.metadata.lastTillEnd"
                    dense
                    class="ma-0 toggle-input"
                    color="primary"
                    hide-details
                    @change="handleLastTillEnd"
                  ></v-switch>
                </v-row>
              </v-col>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="my-6"></v-divider>
        <v-card-text>
          <v-row class="px-1 pb-2" v-if="isEditing">
            <v-col
              class="d-flex"
              :class="isMobileBreakpoint ? 'justify-center' : 'justify-end'"
            >
              <base-btn
                type="tertiary"
                class="mr-2"
                min-width="150"
                :disabled="withoutChanges || cantUpload"
                @click="handleCancelEditing"
              >
                {{ $t('message.actions.cancel') }}
              </base-btn>
              <base-btn
                min-width="150"
                :disabled="withoutChanges || cantUpload"
                :loading="loadings.removingCta || loadings.creatingCta"
                @click="
                  openUploadMiniTrigger = false
                  handlePublishNewCta()
                "
                >{{ $t('message.pages.videoPlayerButtons.publish') }}
              </base-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <portal to="actions-footer">
      <div class="d-flex flex-row actions-row">
        <v-spacer></v-spacer>
        <v-tooltip max-width="184px" :disabled="!noChanges" top>
          <template v-slot:activator="{ on, attrs }">
            <div class="pl-2" v-bind="attrs" v-on="on">
              <base-btn
                v-if="hasEditVideoPerm"
                :disabled="noChanges || loadings.creatingCta"
                type="tertiary"
              >
                {{ $t('message.actions.cancel') }}
              </base-btn>
            </div>
          </template>
          <span>{{ $t('message.noChanges') }}</span>
        </v-tooltip>
        <v-tooltip max-width="184px" :disabled="!noChanges" top>
          <template v-slot:activator="{ on, attrs }">
            <div class="pl-2" v-bind="attrs" v-on="on">
              <base-btn
                :disabled="noChanges || loadings.creatingCta"
                :loading="loadings.creatingCta"
                v-if="hasEditVideoPerm"
              >
                {{ $t('message.actions.publish') }}
              </base-btn>
            </div>
          </template>
          <span>{{ $t('message.noChanges') }}</span>
        </v-tooltip>
      </div>
    </portal> -->
  </v-card>
</template>

<script>
// import InputImages from '@/components/InputImages.vue'
import download from 'downloadjs'
import { mapMutations, mapState } from 'vuex'
import _ from 'lodash'
import playerApi from '@/services/playerApi'
import { v4 as uuidv4 } from 'uuid'
import i18n from '@/translations/lang.js'
import UnsavedChangesModal from '@/components/UnsavedChangesModal.vue'
import imagesApi from '@/services/imagesApi.js'
import AntTimePicker from '@/components/AntTimePicker.vue'
import previewThumbCard from '@/components/previewThumbCard.vue'
import BaseDropZone from '../../../components/BaseDropZone.vue'
import BaseBtn from '../../../components/BaseBtn.vue'
export default {
  name: 'VideoPlayerMiniTrigger',
  components: {
    // InputImages,
    previewThumbCard,
    UnsavedChangesModal,
    BaseDropZone,
    AntTimePicker,
    BaseBtn,
  },
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    customVideoId: {
      required: false,
    },
    hasEdit: {
      type: Array,
    },
  },
  data: () => ({
    renderTick: 0,
    isEditing: false,
    isUploading: false,
    timeVideo: 0,
    dataImage: false,
    openUploadMiniTrigger: false,
    unsavedChanges: false,
    loading: false,
    showAll: false,
    showCounter: false,
    loadings: {
      creatingCta: false,
      removingCta: false,
    },
    editingMiniTrigger: {},
    initialEditingMiniTrigger: {},
    defaultEditingMiniTrigger: {
      id: null,
      title: i18n.t('message.pages.video.miniTrigger.namePlaceHolder'),
      metadata: {
        lastAllVideo: false,
        lastTillEnd: false,
        previewImage: {
          url: '',
          id: null,
        },
        endTime: '00:05',
        startTime: '00:00',
      },
    },
    incomingCta: false,
    imageName: '',
    articleLinks: {
      pt: 'https://help.pandavideo.com/pt-br/article/como-funciona-e-como-usar-os-mini-gatilhos-zvgkcr/',
      en: 'https://help.pandavideo.com/en-us/article/how-does-it-work-and-how-to-use-the-mini-triggers-9mz2ji/',
    },
  }),
  watch: {
    editingMiniTrigger: {
      handler() {
        if (this.isEditing) {
          this.checkPreview()
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      video: (state) => state.video.video,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    isVertical() {
      return this.video.height > this.video.width
    },
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
    noChanges() {
      return _.isEqual(this.editingMiniTrigger, this.initialEditingMiniTrigger)
    },
    checkNameIsExist: {
      get() {
        if (!this.editingMiniTrigger.title) return false
        return this.allCtasVideo.some(
          (trigger) =>
            trigger.title == this.editingMiniTrigger.title &&
            trigger.id !== this.editingMiniTrigger.id
        )
      },
      deep: true,
      cache: false,
    },
    checkIfIsBetweenInterval: {
      get() {
        if (
          !this.formatTimeToSeconds(
            this.editingMiniTrigger.metadata.startTime
          ) &&
          this.formatTimeToSeconds(
            this.editingMiniTrigger.metadata.startTime
          ) !== 0
        )
          return false
        let hasNewThumbCreated = false
        let x = this.allCtasVideo.map((el) => {
          if (el.id === this.editingMiniTrigger.id)
            return { start: -1, end: -1 }
          if (
            !hasNewThumbCreated &&
            (el.metadata.startTime || el.metadata.endTime)
          ) {
            hasNewThumbCreated = true
          }
          return {
            start: this.formatTimeToSeconds(el.metadata.startTime),
            end: this.formatTimeToSeconds(el.metadata.endTime),
          }
        })
        let result = []
        let z = {
          start: this.formatTimeToSeconds(
            this.editingMiniTrigger.metadata.startTime
          ),
          end: this.formatTimeToSeconds(
            this.editingMiniTrigger.metadata.endTime
          ),
        }
        if (hasNewThumbCreated) {
          result = x.filter(
            (i) =>
              this.inRange(z.start, i.start, i.end) ||
              this.inRange(z.end, i.start, i.end)
          )
        } else {
          result = x.filter(
            (i) =>
              this.inRange(z.start, i.start, i.end) ||
              this.inRange(z.end, i.start, i.end)
          )
        }
        return !!result.length
      },
      deep: true,
      cache: false,
    },

    cantUpload: {
      get() {
        if (!this.editingMiniTrigger.metadata.previewImage.url) {
          return true
        }
        if (!this.editingMiniTrigger.title) {
          return true
        }
        return this.checkNameIsExist || this.checkIfIsBetweenInterval
      },
      cache: false,
      deep: true,
    },
    allCtasVideo: {
      get() {
        const videoCtas = this.video?.config?.ctas ?? []
        if (videoCtas.length) {
          return videoCtas.filter((cta) => cta.metadata?.isMiniTrigger)
        }
        return []
      },
      cache: false,
    },
    isLowerOrEqual() {
      const { endTime, startTime } = this.editingMiniTrigger.metadata
      return endTime < startTime
    },
    timePickerRenderKeys: {
      get() {
        const ret = {
          start: `start__${this.editingMiniTrigger.id}-${this.renderTick}`,
          end: `end__${this.editingMiniTrigger.id}-${this.renderTick}`,
        }
        return ret
      },
      deep: true,
      cache: false,
    },
    withoutChanges: {
      get() {
        if (
          this.editingMiniTrigger.title ==
            this.initialEditingMiniTrigger.title &&
          this.editingMiniTrigger.metadata.lastAllVideo ==
            this.initialEditingMiniTrigger.metadata.lastAllVideo &&
          this.editingMiniTrigger.metadata.endTime ==
            this.initialEditingMiniTrigger.metadata.endTime &&
          this.editingMiniTrigger.metadata.startTime ==
            this.initialEditingMiniTrigger.metadata.startTime &&
          this.editingMiniTrigger.metadata.lastTillEnd ==
            this.initialEditingMiniTrigger.metadata.lastTillEnd
        ) {
          return true
        } else return false
      },
      deep: true,
      cache: false,
    },
  },
  methods: {
    ...mapMutations('video', ['UPDATE_VIDEO']),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    handleGoToArticle() {
      const articleLink =
        this.articleLinks[this.$i18next.resolvedLanguage] ??
        this.articleLinks['en']
      window.open(articleLink, '_blank')
    },
    processFileInput(files) {
      let file = files
      if (file.type.match('image.*')) {
        let reader = new FileReader()
        reader.onloadend = function () {
          const results = {
            filePreview: reader.result,
            file: file,
          }
          this.saveImageLink(results)
        }.bind(this)
        reader.readAsDataURL(file)
      }
    },
    async handleRemoveCta(cta, dontRefreshConfig, oldVideoID) {
      const videoID = oldVideoID ?? this.video.id
      this.isEditing = false
      try {
        this.loadings.removingCta = true
        this.beingRemovedCtaId = cta.id

        const { data } = await playerApi.deleteCta(videoID, cta.id)
        if (
          cta?.metadata?.previewImage?.url &&
          cta?.metadata?.previewImage?.id
        ) {
          await imagesApi.deleteImage(cta.metadata.previewImage.id)
        }

        this.video.config = data
        this.UPDATE_VIDEO(this.video)
        if (!dontRefreshConfig) this.refreshConfig()

        this.loadings.removingCta = false
        this.error = ''
        const text = this.$i18next.t(
          'message.pages.video.miniTrigger.tooltips.remove'
        )
        this.UPDATE_GLOBAL_SNACKBAR({ open: true, text, type: 'success' })
      } catch (error) {
        this.error = this.$t(
          'message.pages.video.buttonsPage.errors.removeError'
        )
        this.loadings.removingCta = false
        console.error(error)
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    handleEditCta(cta, i) {
      this.isUploading = false
      this.resetFormData()
      if (cta) {
        this.editingMiniTrigger = _.cloneDeep(cta)
        this.initialEditingMiniTrigger = _.cloneDeep(cta)
        this.incomingCta = i
      } else {
        this.incomingCta = false
      }
      this.showAll = !this.editingMiniTrigger.metadata.lastAllVideo
      this.openUploadMiniTrigger = true
      this.isEditing = true
      this.$root.$emit('updateEmbedPreviewChange')
    },
    async saveImageLink(data) {
      this.isUploading = true
      this.dataImage = data
      this.imageName = data.file?.name ? data.file?.name : ''
      this.editingMiniTrigger.title = this.imageName.slice(0, 40)
      this.editingMiniTrigger.metadata.previewImage.url = data.filePreview
        ? data.filePreview
        : ''
      if (this.isUploading && this.allCtasVideo.length > 0)
        this.handleLastAllVideo()
      else this.editingMiniTrigger.metadata.lastAllVideo = true
      this.editingMiniTrigger.metadata.endTime = this.formatSecondsToTime(
        this.timeVideo
      )
      this.checkPreview()
      this.isEditing = true
    },
    async checkPreview() {
      const cta = await this.generateCta()

      if (this.video.hasOwnProperty('video_source')) {
        const ctas = cta?.metadata?.previewImage?.url
          ? [cta]
          : this.video.config.ctas
        this.$root.$emit('setCtas', ctas)
      } else {
        const iframe = document.getElementById('panda-player').contentWindow
        iframe.postMessage(
          {
            type: 'ctas',
            parameter: {
              ctas: cta?.metadata?.previewImage?.url
                ? [cta]
                : this.video.config.ctas,
            },
          },
          '*'
        )
      }
    },

    handleGetBack(ignoreEquality = false) {
      if (!this.noChanges && !ignoreEquality && this.isEditing) {
        this.$root.$emit('unsavedChangesModal', false, false, true)
        this.$root.$emit('updateEmbedPreviewChange')
      } else {
        if (this.isEditing && this.allCtasVideo.length !== 0) {
          this.isEditing = false
        } else {
          this.handleBack()
        }
      }
    },
    refreshConfig() {
      if (this.video.hasOwnProperty('video_source')) {
        this.$root.$emit('setCtas', this.video.config.ctas)
      } else {
        const iframe = document.getElementById('panda-player').contentWindow
        iframe.postMessage(
          {
            type: 'ctas',
            parameter: {
              ctas: this.video.config.ctas,
            },
          },
          '*'
        )
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    handleStartTimeEvent(time) {
      this.editingMiniTrigger.metadata.startTime = time
    },
    handleEndTimeEvent(time) {
      this.editingMiniTrigger.metadata.endTime = time
    },
    formatTimeToSeconds(time) {
      let res = time.split(':').reduce((acc, time) => 60 * acc + +time)
      return res
    },
    async generateCta(isDeploy = false) {
      const id = uuidv4()

      if (!this.editingMiniTrigger.id || this.editingMiniTrigger.id === '') {
        this.editingMiniTrigger.id = id
        this.initialEditingMiniTrigger.id = id
      }

      if (isDeploy) this.editingMiniTrigger.id = id

      let time = this.formatTimeToSeconds(
        this.editingMiniTrigger.metadata.startTime
      )
      let duration =
        this.formatTimeToSeconds(this.editingMiniTrigger.metadata.endTime) -
        this.formatTimeToSeconds(this.editingMiniTrigger.metadata.startTime)

      if (duration < 1) {
        duration = 0
      }
      if (this.editingMiniTrigger.metadata.lastAllVideo) {
        time = 0
        duration = this.timeVideo
      }
      if (this.editingMiniTrigger.metadata.lastTillEnd) {
        duration = this.timeVideo
      }

      if (isDeploy) {
        const data = await fetch(
          this.editingMiniTrigger.metadata.previewImage.url
        )
        const blobData = await data.blob()
        const imageData = await imagesApi.handleUploadImage(blobData, [
          {
            filename:
              this.imageName ||
              this.initialEditingMiniTrigger.metadata.previewImage.url
                .split('/')
                .pop(),
            type: 'cta',
          },
        ])
        this.editingMiniTrigger.metadata.previewImage.url = `${imageData.cdn_base}/${imageData.storage_path}`
        this.editingMiniTrigger.metadata.previewImage.id = imageData.id
      }
      const cta = {
        id: this.editingMiniTrigger.id,
        title: this.editingMiniTrigger.title,
        type: 'video',
        time: time,
        duration: duration,
        script:
          '<script>function play() { window.parent.postMessage({type:"togglePlay",}, "*")};</scr' +
          `ipt><style> .miniTrigger-image { display: flex; max-width: 100%; height: 100%; justify-content: center; align-items: center; margin: auto; } body { overflow: hidden; } .miniTrigger-image img { max-width: 80%; max-height: 80% } </style><div class="miniTrigger-image" onclick="play()"><img src="${this.editingMiniTrigger.metadata.previewImage.url}" /></div>"`,
        metadata: {
          ...this.editingMiniTrigger.metadata,
          isMiniTrigger: true,
          fadeConfigs: { fadeInMs: 200, fadeOutMs: 200 },
        },
      }
      return cta
    },
    toggleLastAllVideoState() {
      if (this.showAll) {
        this.editingMiniTrigger.metadata.startTime = '00:00'
        this.editingMiniTrigger.metadata.endTime = this.formatSecondsToTime(
          this.timeVideo
        )
        return (this.editingMiniTrigger.metadata.lastAllVideo = false)
      }
      this.editingMiniTrigger.metadata.lastAllVideo = true
      this.handleLastAllVideo()
    },
    async handlePublishNewCta() {
      // if (this.noChanges) return this.handleGetBack(true)

      this.loadings.creatingCta = true

      try {
        const generatedCtas = await this.generateCta(true)
        const oldVideoID = this.video.id

        let { data } = await playerApi.addCta(this.video.id, generatedCtas)
        this.video.config = data
        this.UPDATE_VIDEO(this.video)
        if (this.initialEditingMiniTrigger.metadata?.previewImage?.url) {
          await this.handleRemoveCta(
            this.initialEditingMiniTrigger,
            true,
            oldVideoID
          )
          this.isUploading = false
          this.isEditing = false
        } else {
          this.isUploading = false
          this.refreshConfig()
        }
        this.handleCancelEditing()
      } catch (err) {
        this.isUploading = false
        console.error(err)
      } finally {
        const text = this.$i18next.t(
          'message.pages.video.miniTrigger.tooltips.add'
        )
        this.UPDATE_GLOBAL_SNACKBAR({ open: true, text, type: 'success' })
        this.isEditing = false
        this.loadings.creatingCta = false
        this.isUploading = false
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    handleDownloadThumb(thumbUrl, name) {
      this.loadings.removingCta = true

      const img = new Image()
      img.crossOrigin = 'anonymous' // Evita problemas de CORS (se permitido pelo servidor)
      img.src = thumbUrl

      img.onload = () => {
        const canvas = new OffscreenCanvas(img.width, img.height)
        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0)

        canvas
          .convertToBlob()
          .then((blob) => {
            if (!blob) {
              this.loadings.removingCta = false
              return
            }

            let filename = thumbUrl.split('/').pop()
            filename = name || filename

            download(blob, filename)
          })
          .finally(() => {
            this.loadings.removingCta = false
          })
      }

      img.onerror = () => {
        this.loadings.removingCta = false
      }
    },
    inRange(x, min, max) {
      return (x - min) * (x - max) <= 0
    },
    handleCancelEditing() {
      this.isEditing = false
      this.openUploadMiniTrigger = false
      this.showAll = false
      this.resetFormData()
      this.checkPreview()
      this.dataImage = false
      this.$root.$emit('updateEmbedPreviewChange')
    },
    resetFormData() {
      this.editingMiniTrigger = _.cloneDeep(this.defaultEditingMiniTrigger)
      this.initialEditingMiniTrigger = _.cloneDeep(this.editingMiniTrigger)
      this.dataImage = false
    },
    handleLastAllVideo() {
      if (this.editingMiniTrigger.lastAllVideo) {
        this.editingMiniTrigger.startTime = '00:00'
        this.editingMiniTrigger.endTime = this.formatSecondsToTime(
          this.timeVideo
        )
        this.editingMiniTrigger.lastTillEnd = false
      }
      this.showAll = !this.editingMiniTrigger.metadata.lastAllVideo
    },
    handleLastTillEnd() {
      if (this.editingMiniTrigger.lastTillEnd) {
        this.editingMiniTrigger.endTime = this.formatSecondsToTime(
          this.timeVideo
        )
        this.editingMiniTrigger.lastAllVideo = false
      }
    },
    formatSecondsToTime(seconds) {
      if (!seconds) return '00:00'
      const res = new Date(seconds * 1000).toISOString()
      if (this.timeVideo < 3600) {
        return res.substring(14, 19)
      }
      return res.substring(11, 19)
    },
    formatTime(timeString) {
      if (!timeString) return '00:00'

      const totalSeconds = parseFloat(timeString)
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = Math.floor(totalSeconds % 60)

      const formattedMinutes = String(minutes).padStart(2, '0')
      const formattedSeconds = String(seconds).padStart(2, '0')

      if (hours > 0) {
        const formattedHours = String(hours).padStart(2, '0')
        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
      } else {
        return `${formattedMinutes}:${formattedSeconds}`
      }
    },
  },
  mounted() {
    this.$root.$on('discardChangesMiniTriggerPage', () => {
      this.editingMiniTrigger = { ...this.initialEditingMiniTrigger }
      this.handleGetBack()
    })
    this.resetFormData()
    this.timeVideo = this.$store.state.video.video?.length
    this.isEditing = false
    this.hasEdit.push(!this.noChanges && this.isEditing)
  },
}
</script>

<style lang="scss" scoped>
.neutral-60--text {
  color: varFigma(neutral-60);
}
::v-deep .v-list-item {
  cursor: pointer;
  transition: background-color 0.3s;
}

::v-deep .v-list-item:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

::v-deep .v-list-item.theme--dark:hover {
  background-color: #292b35 !important;
}
::v-deep .v-input--selection-controls__input {
}
::v-deep .v-list-item__title.disabled-v-list-item-title {
  color: varFigma(neutral-70) !important;
}
::v-deep .v-list-item__title.remove-v-list-item-title {
  color: varFigma(feedback-danger) !important;
}
.disabled-v-list-item {
  cursor: not-allowed;
}
::v-deep .v-text-field__slot .v-label {
  margin-left: -10px;
}
::v-deep .v-radio:has(i.mdi-radiobox-marked)::before {
  width: 18px;
  height: 18px;
  left: 3px;
  border: 5px solid var(--brand-60-base-light);
  top: unset;
}
::v-deep .v-radio:has(i.mdi-radiobox-marked)::after {
  width: 14px;
  height: 14px;
  left: 3px;
  top: unset;
}
::v-deep .v-list-item__title {
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 150% !important; /* 18px */
  color: varFigma(neutral-30) !important;
}
::v-deep .v-radio {
  margin-bottom: 16px;
}
::v-deep .v-menu__content {
  border-radius: var(--spacing-01, 2px) !important;
  border: 1px solid varFigma(neutral-95-lightest) !important;
  background: varFigma(neutral-100-white) !important;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15) !important;
}
::v-deep .error-timer input {
  border-color: varFigma(feedback-danger-light) !important;
  background-color: varFigma(feedback-danger-background) !important;
  color: varFigma(feedback-danger) !important;
}
.base-button.panda-icons.--thumbnail {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  width: 32px !important;
  padding: 3px;
  height: 32px;
}
.panda-menu-action {
  margin-left: 16px;
}
::v-deep .hide-icon-time-picker {
  width: 52px;
}
::v-deep .hide-icon-time-picker > .ant-time-picker-icon {
  display: none;
}
</style>
